<template>
  <div class="notes">
    <h5>Notes:</h5>
    <div class="notes-container">
      <div v-for="note in notes" :key="note.id"
      class="note"
      >
        <div class="note-content">
          {{ note.note }}
        </div>
        <div class="note-details">
        {{ formatDate(note.created_at) }} by {{ note.posted_by.name }}
        </div>
      </div>
    </div>
    <div class="note-input">
      <div class="d-flex">
        <input type="text" v-model="note" id="noteInput"  placeholder="Write a note..." required
        @keyup.enter="addNote"
        >
        <button type="button" class="btn btn-action"
        @click="addNote"
        >Add</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { useStore } from "vuex";

export default {
  props: ['notes', 'user'],
  data() {
    return {
      note: '',
    }
  },
  setup() {
    const store = useStore();
    return { 
      store 
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMMM D, YYYY [at] h:mm a');
    },
    addNote() {
      this.store.dispatch('addUserNote', {
        note: this.note,
        userId: this.user.id
      })
      .then((resp) => {

        if( resp.data.status === 'success' ){
          this.notes.unshift(resp.data.note);
        }
      });
      this.note = '';
    }
  }
}
</script>